module.exports = {
  title: 'Image Editor with Skia, Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2024-03-27',
  slug: 'prequel-slider',
  tags: ['skia', 'reanimated', 'gesture-handler'],
};
